import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlarmClock } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { DeadlineBadge } from "@/components/DeadlineBadge";

export const DueSoon = ({ onLoad }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/deadlines").then((r) => { setItems(r.data); onLoad?.(new Set(r.data.map((x) => x.id))); }).catch(() => toast.error("Could not load loan deadlines")); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!items.length) return null;
  return (
    <section className="rounded-xl border border-rose-500/30 bg-rose-500/5 p-6 mb-8" data-testid="due-soon">
      <h2 className="flex items-center gap-2 font-display text-lg font-semibold text-rose-200 mb-4"><AlarmClock className="h-5 w-5" />Loan deadlines due soon <span className="num text-sm px-2 rounded-full bg-rose-500/20">{items.length}</span></h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((s) => (
          <Link key={s.id} to={`/studies/${s.id}`} data-testid={`due-soon-${s.id}`} className="rounded-lg border border-slate-800 bg-slate-950/50 p-4 hover:border-rose-400/50 transition-colors">
            <p className="font-semibold truncate mb-1">{s.name}</p>
            <div className="flex items-center justify-between gap-2"><DeadlineBadge date={s.loan_deadline} testId={`due-soon-badge-${s.id}`} /><span className="text-xs text-slate-500 capitalize">{s.status}</span></div>
          </Link>
        ))}
      </div>
    </section>
  );
};
